import React                    from 'react'
import { 
    Container,
    Hero,
    Section,
    Services,
    Sectors,
    Blogs,
    Helper
}                               from "./components"

const Landing = () => {
    return (
        <Container>
            <Hero />
            <Services />
            <Section />
            <Sectors />
            <Blogs />
            <Helper />
        </Container>
    )
}

export default Landing
